<template>
    <div>
        <b-card>
             <b-tabs pills card>
                <b-tab title="Reporte Entrada Y salida" active>
                <b-row>    
                    <b-col md="3">
                    <br>
                    <label for="Fecha">Fecha Inicial</label> 
                    <b-input-group>
                    <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="date" required v-model="fechaIniES"></b-form-input>
                    </b-input-group>
                    </b-col>
                    <b-col md="3">
                    <br>
                    <label for="Fecha">Fecha Final</label> 
                    <b-input-group>
                    <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="date" required v-model="fechaFinES"></b-form-input>
                    </b-input-group>
                    </b-col>
                    <b-col md="3">
                    <br>
                        <label for="nombre">Doc. Usuario</label>
                        <b-form-input v-model="idES"  type="text"  placeholder="Doc. Identificacion" text="Buscar" ></b-form-input>
                    </b-col>
                    <b-col md="2">
                        <br>
                        <label for="Tipo">Tipo De Usuario</label> 
                        <b-form-group label-for="Tipo">
                        <b-form-select :options="opciones" v-model="tipoES"></b-form-select>
                        </b-form-group>
                    </b-col>
                     <b-col md="1">
                        <br>
                        <br>
                        <b-button variant="success" @click="enviarES" >Generar</b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <List :mapState="'controlaccesoreports'" v-if="mostrarTES" :exportExcel="true" :showbtn="false" :allDispatch="'controlaccesoreportsaux'"></List>
                    </b-col>
                </b-row>
                </b-tab>
                <b-tab title="Reporte Permisos">
                <b-row>    
                    <b-col md="3">
                    <br>
                    <label for="Fecha">Fecha Inicial</label> 
                    <b-input-group>
                    <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="date" required v-model="fechaIniPe"></b-form-input>
                    </b-input-group>
                    </b-col>
                    <b-col md="3">
                    <br>
                    <label for="Fecha">Fecha Final</label> 
                    <b-input-group>
                    <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="date" required v-model="fechaFinPe"></b-form-input>
                    </b-input-group>
                    </b-col>
                    <b-col md="3">
                    <br>
                        <label for="nombre">Doc. Usuario</label>
                        <b-form-input v-model="idPe"  type="text"  placeholder="Doc. Identificacion" text="Buscar"></b-form-input>
                    </b-col>
                    <b-col md="2">
                        <br>
                        <label for="Tipo">Tipo De Usuario</label> 
                        <b-form-group label-for="Tipo">
                        <b-form-select :options="opciones" v-model="tipoPe"></b-form-select>
                        </b-form-group>
                    </b-col>
                     <b-col md="1">
                        <br>
                        <br>
                        <b-button variant="success" @click="enviarPe" >Generar</b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <List :mapState="'controlaccesoreports'" :exportExcel="true" :showbtn="false" v-if="mostrarTPe"  :allDispatch="'controlaccesoreportsaux'"></List>
                    </b-col>
                </b-row>
                </b-tab>
                <b-tab title="Reporte inasistencia por dia" active>
                <b-row>    
                    <b-col md="3">
                    <br>
                    <label for="Fecha">Fecha</label> 
                    <b-input-group>
                    <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="date" required v-model="fechaFallo"></b-form-input>
                    </b-input-group>
                    </b-col>
                     <b-col md="1">
                        <br>
                        <br>
                        <b-button variant="success" @click="enviarFallos" >Generar</b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <List :mapState="'controlaccesoreports'" v-if="mostrarFallos" :exportExcel="true" :showbtn="false" :allDispatch="'controlaccesoreportsaux'"></List>
                    </b-col>
                </b-row>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import List from '@/components/modules/base/list.vue'
export default {
 name: 'reports', 
 data (){
     return{
         fechaFallo:'',
         fechaIniES:'',
         fechaFinES:'',
         idES:'',
         tipoES:'',
         fechaIniPe:'',
         fechaFinPe:'',
         idPe:'',
         tipoPe:'',
         mostrarTES:false,
         mostrarTPe:false,
         mostrarFallos:false,
         opciones:[{
            'value': 1,
            'text': 'Entrada'
        },{
            'value': 2,
            'text': 'Salida '
        }]

     }

 },
 components: {
    List
  },
  methods:{
        enviarPe(){
            this.mostrarTPe = false
            let array={'fechaIniPe':this.fechaIniPe+' 00:00:00','fechafinPe':this.fechaFinPe+' 23:00:00','idUserPe':this.idPe,'tipoPe':this.tipoPe}
            let mostrarTPe= ''
            this.$store.dispatch('controlaccesoreportslistPe', array).then(Response=>{
                if(this.$store.getters.controlaccesoreports.name != ''){
                    
                    this.mostrarTPe=true
                }else{
                    this.mostrarTPe=false
                }
                
            }).catch(error=>{
                console.log(error)
            })  
         
        },
        enviarFallos(){
            this.mostrarFallos = false
            let array={'fechaFallo':this.fechaFallo}
            let mostrarFallos= ''
            this.$store.dispatch('controlaccesoreportsFallos', array).then(Response=>{
                if(this.$store.getters.controlaccesoreports.name != ''){
                    
                    this.mostrarFallos=true
                }else{
                    this.mostrarFallos=false
                }
                
            }).catch(error=>{
                console.log(error)
            })  
         
        },
        enviarES(){
            this.mostrarTES = false
            let  array={'fechaIniES':this.fechaIniES+' 00:00:00','fechafinES':this.fechaFinES+' 23:59:00','idUserES':this.idES,'tipoES':this.tipoES}
            let mostrarTES= ''
            this.$store.dispatch('controlaccesoreportslistES', array).then(Response=>{
                if(this.$store.getters.controlaccesoreports.name != ''){
                    this.List= this.$store.getters.controlaccesoreports
                    this.mostrarTES=true
                }else{
                    this.mostrarTES=false
                }
                
            })  
         
        }
}
}
</script>



// WEBPACK FOOTER //
// src/components/modules/controlacceso/reports.vue